import DefaultDataProvider from '../providers/defaultDataProvider';
import useInitDataProviderParams from './useInitDataProviderParams';

const useInitDataProvider = () => {
    const { apiUrl, urlsProvider, getHeaders, tenant } = useInitDataProviderParams();

    return new DefaultDataProvider(apiUrl, urlsProvider, getHeaders, tenant);
};

export default useInitDataProvider;
